import { useState } from 'react';
import { TabBar } from '../../components/TabBar/TabBar';
import { PageContainer } from '../../containers/PageContainer/PageContainer';
import { Copy } from '../../copy/Copy';
import {
  marginTop24Sx,
  tabPanelContainerSx,
  tableTabPanelContainerSx,
} from '../../styles/Global.style';
import TabContext from '@mui/lab/TabContext/TabContext';
import TabPanel from '@mui/lab/TabPanel/TabPanel';
import { SpotifyCard } from '../../components/SpotifyCard/SpotifyCard';
import { NavTabBar } from '../../components/NavTabBar/NavTabBar';
import { COMMUNITY_NAV_TABS } from '../../constants/community';
import { Feed } from '../../components/Feed/Feed';
import { mapLeaderboardTabs } from '../../helpers/mapLeaderboardTabs';
import { Loading } from '../../components/Loading/Loading';
import { useCommunity } from '../../hooks/useCommunity/useCommunity';

export const Community = () => {
  const {
    feed,
    playlist,
    leaderboard,
    isFeedLoading,
    isLeaderboardLoading,
    isPlaylistLoading,
  } = useCommunity();
  const [tabValue, setTabValue] = useState('1');

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <PageContainer title={Copy.generate('Global.community')}>
      <TabContext value={tabValue}>
        <NavTabBar
          handleChange={handleTabChange}
          ariaLabel="Community tab bar"
          tabs={COMMUNITY_NAV_TABS}
        />

        <>
          <TabPanel id="section" value="1" sx={tabPanelContainerSx}>
            {!isFeedLoading ? <Feed feed={feed} /> : <Loading />}
          </TabPanel>

          <TabPanel id="section" value="2" sx={tableTabPanelContainerSx}>
            {!isLeaderboardLoading ? (
              <TabBar
                tabs={mapLeaderboardTabs(leaderboard)}
                sx={marginTop24Sx}
              />
            ) : (
              <Loading />
            )}
          </TabPanel>

          <TabPanel id="section" value="3" sx={tabPanelContainerSx}>
            {!isPlaylistLoading ? (
              <SpotifyCard playlist={playlist} />
            ) : (
              <Loading />
            )}
          </TabPanel>
        </>
      </TabContext>
    </PageContainer>
  );
};
